import { MicrositeRepository } from "../../../repositories/micrositeRepository"
import { UseCase } from "../../useCase"
import { UpdateLandingReviewsBySlugRequest } from "./request"
import { UpdateLandingReviewsBySlugResponse } from "./response"

export class UpdateLandingReviewsBySlugUseCase
	implements UseCase<UpdateLandingReviewsBySlugRequest, UpdateLandingReviewsBySlugResponse>
{
	private _repository

	constructor({ MicrositeRepository }: { MicrositeRepository: MicrositeRepository }) {
		this._repository = MicrositeRepository
	}

	exec({ slug, reviews }: UpdateLandingReviewsBySlugRequest) {
		return this._repository.updateLandingReviewsBySlug(slug, reviews)
	}
}
